module.exports = __webpack_public_path__ + "img/star-image-2.7b8fb78a.png";